// Keeping this here for simplification, till we can fix this mapping on the backend

export const aobIdToBusinessChannel = new Map([
    ["amazon_air_aob" , "Amazon_Air"],
    ["comixology_aob" , "Comixology"],
    ["global_stores_3p_revenue_share" , "Global_Stores"]
]);
